import APPOINTMENT_INITIAL_STATE from './appointment.initial-state';
import APPOINTMENT_MUTATIONS from './appointment.mutations';
import APPOINTMENT_GETTERS from './appointment.getters';
import APPOINTMENT_ACTIONS from './appointment.actions';

// ============================================================================
// :: APPOINTMENT MODULE STORE
// ============================================================================

const appointmentStore = {
  name: 'appointment',
  namespaced: true,
  state: APPOINTMENT_INITIAL_STATE(),
  mutations: APPOINTMENT_MUTATIONS,
  actions: APPOINTMENT_ACTIONS,
  getters: APPOINTMENT_GETTERS,
};

export {
  appointmentStore,
};
